import { getFirestore, doc, updateDoc, getDoc } from "firebase/firestore";
import { getApp } from 'firebase/app';
import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  isUser: boolean = false;
  user !: string

  setUser(user: string) {
    this.user = user
  }
  getUserStatus() {
    return this.isUser;
  }

  addUserInfo(name: string, bio: string, interests: string[], housing: string) {
    const firestoreDB = getFirestore(getApp());
    const usersCollection = doc(firestoreDB, "users", this.user);
    const userData = {
      name: name,
      interests: interests,
      housing: housing,
    }

    updateDoc(usersCollection, userData)
      .then(userData => {
        console.log("user added!");
      })
      .catch(error => {
        console.log(error);
      })
  }

  async checkIfUser(email: string) {
    const firestoreDB = getFirestore(getApp());
    const username = email.split("@")[0];
    const docRef = doc(firestoreDB, "users", username);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      //this email is in our user collection.
      console.log("hello sir this means user worked");

      this.isUser = true;
    }
    else {
    }
  }
}
